<app-base-top-app-bar
  [user$]="user$"
  [userRoleLabel]="'Logged in as'"
  [showBalance]="showBalance"
  [showBilling]="showBilling"
  [showLegalLinks]="showLegalLinks"
  [logoLink]="logoLink"
  (signOut)="onSignOut()"
  (switchAccount)="onSwitchAccount()"
  class="landing-theme"
>
  <!-- Landing pages have minimal content - just the logo is enough -->
  <div slot="content" class="landing-content">
    <!-- Intentionally minimal - just spacing for visual balance -->
  </div>

  <!-- Additional user menu items for landing page -->
  <div slot="user-menu">
    <button mat-menu-item (click)="onSwitchAccount()">
      <mat-icon>swap_horiz</mat-icon>
      <span>Switch Account</span>
    </button>
  </div>
</app-base-top-app-bar>
